var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":function($event){return _vm.closeFlyouts()}}},[_c('BaseIconSpriteMap'),(_vm.showNav)?_c('NavHeader',{key:this.getItemCount('all')}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }